




import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import NewContainer from '@/containers/cv-section-skill/new.vue';
import * as CvSectionSkillStoreNew from '@/store/modules/cvSectionSkillNew';

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook],
  data() {
    return {
      storeList: [CvSectionSkillStoreNew],
    };
  },
});
